module.exports = __webpack_public_path__ + "img/2_3.25a67bde.png";